<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetSourceList' }">预算源组</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="RID：">
                                    <el-input v-model="list.rid" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预算项目：">
                                    <div class="read_only read_only_link">
                                        <span @click="budgetItemClick(list.budget_item_rid)">{{ list.budget_item_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算源组：">
                                    <div class="read_only read_only_link">
                                        <span
                                            v-if="list.budget_item_source_group"
                                            @click="budgetItemSourceClick(list.budget_item_source_group.rid)"
                                        >
                                            {{ list.budget_item_source_group.name }}</span
                                        >
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="生效期间：">
                                    <el-input v-model="list.period" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="金额：">
                                    <el-input v-model="list.amount" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="备注：">
                                    <el-input v-model="list.remark" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="审批状态：">
                                    <el-input
                                        v-model="list.approval_status_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12"> <el-form-item label="" prop=""> </el-form-item> </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="提交人：">
                                    <el-input
                                        v-model="list.submission_operator_name"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="审批人：">
                                    <el-input
                                        v-model="list.decision_operator_name"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="生效日期：">
                                    <el-input
                                        v-model="list.effective_date"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="生效状态：">
                                    <el-input
                                        v-model="list.effectiveness_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'budgetItemSourceDetail',
    data() {
        return {
            list: {},
            activeNames: ['1'],
            rid: '',
            headerTitle: '预算源详情'
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.getDetails();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.$nextTick(() => {
            this.getDetails(); //获取详情
        });
    },
    methods: {
        //预算项目详情
        budgetItemClick(rid) {
            this.$router.push({
                path: 'budgetItemDetails',
                query: {
                    id: rid
                }
            });
        },
        //预算源组详情
        budgetItemSourceClick(rid) {
            this.$router.push({
                path: 'budgetSourceDetail',
                query: {
                    id: rid
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetItemSourceDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({ path: '/budgetSourceList' });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetSourceList' });
            } else {
                this.$router.go(-1);
            }
        },
        //合作方详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetItemSourceDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.rid;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>